import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';

const Container = styled.div`
  min-height: 100vh;
  background-color: #1D1D1D;
  padding: 6rem 2rem 2rem 2rem;
  color: #FFFFFF;
  font-family: 'Montserrat', sans-serif';
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background: #2D2D2D;
  padding: 2rem;
  border: 1px solid #98F9B3;
  border-radius: 0;
`;

const Header = styled.h1`
  color: #98F9B3;
  font-size: 1.5rem;
  margin-bottom: 2rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 600;
`;

const Section = styled.div`
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #3D3D3D;

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
`;

const SectionTitle = styled.h2`
  font-size: 1rem;
  color: #FFFFFF;
  margin-bottom: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

const Detail = styled.p`
  font-size: 0.9rem;
  color: #FFFFFF;
  margin-bottom: 0.5rem;
  letter-spacing: 0.02em;
`;

const HomeButton = styled.button`
  background: #98F9B3;
  color: #000000;
  border: none;
  padding: 0.75rem 1.5rem;
  font-family: 'Montserrat, sans-serif';
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 500;
  cursor: pointer;
  margin-top: 2rem;
  
  &:hover {
    opacity: 0.9;
  }
`;

const OrderConfirmation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { orderDetails } = location.state || {};

  if (!orderDetails) {
    return (
      <Container>
        <Content>
          <Header>Order Information Not Found</Header>
          <HomeButton onClick={() => navigate('/')}>
            Return Home
          </HomeButton>
        </Content>
      </Container>
    );
  }

  return (
    <Container>
      <Content>
        <Header>Order Confirmed!</Header>
        
        <Section>
          <SectionTitle>Order Details</SectionTitle>
          <Detail>Invoice Number: {orderDetails.orderId}</Detail>
          <Detail>Total Amount: ${orderDetails.total}.00</Detail>
          <Detail>Estimated Delivery: {orderDetails.deliveryDate}</Detail>
        </Section>

        <Section>
          <SectionTitle>Items Ordered</SectionTitle>
          {Object.entries(orderDetails.quantities).map(([size, quantity]) => (
            quantity > 0 && (
              <Detail key={size}>
                Size {size}: {quantity} pieces
              </Detail>
            )
          ))}
        </Section>

        <Section>
          <SectionTitle>Shipping Information</SectionTitle>
          <Detail>Name: {orderDetails.customerName}</Detail>
          <Detail>Email: {orderDetails.email}</Detail>
          <Detail>Phone: {orderDetails.phone}</Detail>
        </Section>

        <Section>
          <SectionTitle>Your Design</SectionTitle>
          {orderDetails.designImage && (
            <img 
              src={orderDetails.designImage} 
              alt="Your Design" 
              style={{
                maxWidth: '100%',
                height: 'auto',
                maxHeight: '200px',
                objectFit: 'contain',
                background: '#3D3D3D',
                padding: '1rem'
              }}
            />
          )}
        </Section>

        <HomeButton onClick={() => navigate('/')}>
          Return Home
        </HomeButton>
      </Content>
    </Container>
  );
};

export default OrderConfirmation; 